export default __webpack_public_path__ + "static/media/Thief's Helm of the Stolen Kingdom.41ad0139.jpg";